import { BfPageStoreProvider, useStoreState } from '@tw/tw-runtime-react';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useState } from 'react';
import { ScrollView, Text, TouchableOpacity, View } from 'react-native';
import { TwColumn, TwEmpty, TwImage, TwListItem, TwLoadingBlock, TwPage, TwRow } from '@tw/tw-components-rn';
import { TwTcCommodityAddress, TwTcCommodityCardInfo } from '@tw/tw-templates-rn';

import { BfAppContext } from '@tw/tw-runtime';
import { Divider } from 'native-base';
import { ElementUtils } from '@tw/tw-platform-react';
import { ROUTE_NAMES } from '@/app/navigation/route-names';
import { SettingHistoryOrderNewStore } from '../../stores/history-order-new/setting-history-order-new-store';
import { styles } from './styles';
import { usePageStoreLifecycle } from '@tw/tw-runtime-react';

export const SettingHistoryOrderNew = (props) => {
  const historyOrderStore = SettingHistoryOrderNewStore.getInstance();
  const [store] = useState(() => historyOrderStore);
  usePageStoreLifecycle(store, undefined);

  const isLoading = useStoreState(store, (state) => state.isLoading);
  const datas = useStoreState(store, (state) => state.datas);

  if (isLoading) {
    return <TwLoadingBlock />;
  }
  if (!datas?.length) {
    return (
      <>
        <TwPage.Header title={'历史订单'}></TwPage.Header>
        <TwEmpty description={'暂无订单'} />
      </>
    );
  }

  return (
    <BfPageStoreProvider store={store}>
      <TwPage translucentStatusBar={true}>
        <TwPage.Header title={'历史订单'}></TwPage.Header>
        <ScrollView style={styles.container}>
          <TwColumn space={2}>
            {datas?.map((order, index) => {
              return (
                <TwColumn space={2} style={styles.contentContainer} key={index}>
                  <TwTcCommodityAddress
                    icon={'icon-add-print'}
                    title={ElementUtils.getTextDirectly(order.order.address, 'coordinates')}
                    state={'下单时间'}
                    name={order.order.linkman}
                    mobile={order.order.linkmanPhone}
                    createdTime={order.order.createTime}
                  />
                  <Divider></Divider>
                  <TouchableOpacity
                    onPress={() =>
                      BfAppContext.getInstance()
                        .getRouteService()
                        .push({
                          path: ROUTE_NAMES.SettingHistoryOrderInfo,
                          query: {
                            orderId: order.order.id
                          }
                        })
                    }
                  >
                    {order.goodsInfo.length >= 1 ? (
                      <TwListItem
                        showArrow={true}
                        content={
                          <TwRow space={3}>
                            {order.goodsInfo.slice(0, 3).map((goods, index) => {
                              return <TwImage key={index} style={styles.image} source={goods.showPicture.url} />;
                            })}
                          </TwRow>
                        }
                        rightContent={<Text>共{order.goodsInfo.length}件</Text>}
                      ></TwListItem>
                    ) : (
                      <TwTcCommodityCardInfo
                        key={index}
                        title={order.goodsInfo[0].name}
                        subTitle={''} //{goods.desc}
                        price={order.goodsInfo[0].price}
                        num={order.goodsInfo[0].num}
                        imageUrl={order.goodsInfo[0]?.showPicture?.url}
                      />
                    )}
                  </TouchableOpacity>
                </TwColumn>
              );
            })}
          </TwColumn>
        </ScrollView>
      </TwPage>
    </BfPageStoreProvider>
  );
};
